export default __webpack_public_path__ + "static/media/7.ea95ece1.jpg";